import React from 'react';
import { parseCropHash, getFramedImageStyles } from 'utils/cropUtils';
import { stripHtml } from 'utils/string';
import { ListItem } from './styles';

interface Props {
  img: string;
  dateStr: string;
  title: string;
  description: string;
  slug: string;
}

const NewsCard: React.FC<Props> = (props: Props) => {
  const { img, dateStr, title, description, slug } = props;
  const imageSrc = Array.isArray(img) ? img[0] : img;
  const { cleanUrl, crop } = parseCropHash(imageSrc);
  const { containerStyle, imageStyle } = getFramedImageStyles(crop);

  return (
    <ListItem>
      <a className="news-box" href={'/news/' + slug} rel="noreferrer">
        <div
          style={{
            position: 'relative',
            overflow: 'hidden',
            flexShrink: 0,
            width: '208px',
            height: '100%',
          }}>
          <div
            style={{
              position: 'absolute',
              top: '-10%',
              left: '-10%',
              width: '120%',
              height: '120%',
              background: `url(${cleanUrl}) center center / cover no-repeat`,
              filter: 'blur(15px)',
              zIndex: 1,
            }}
          />
          <div style={containerStyle}>
            <img src={cleanUrl} alt={title} style={imageStyle} />
          </div>
        </div>
        <div className="news-card-information">
          <time>{dateStr}</time>
          <h1>{title}</h1>
          <p>{stripHtml(description)}</p>
          <hr />
          <a href={'/news/' + slug}>Ler Mais</a>
        </div>
      </a>
    </ListItem>
  );
};

export default NewsCard;
